import React, {useState, useRef, useEffect, useCallback, useMemo} from 'react'
import axios from 'axios'
import {useInterval} from "@restart/hooks";
import { isEqual } from 'lodash'


export default function Wordcloud({word_cloud_id, fixed_words, fixed_config, ...props}) {

    const [words, setWords] = useState([])
    const [config, setConfig] = useState({})
    const [querying, setQuerying] = useState(false)
    const [errorMessage, setErrorMessage] = useState(null)

    //const [lastFetch, setLastFetch] = useState(null)

    const fetchWords = () => {
        if(fixed_words) {
            console.log("Ignoring fetch")
            return
        }


        if(word_cloud_id) {
            axios.get("/public/word_clouds/" + word_cloud_id + ".json").then(response => {
                setQuerying(false)
                if (response.status == 200) {
                    //setLastFetch(new Date().getTime() / 1000)
                    if(response.data.words && !isEqual(response.data.words, words)) {
                        setWords(response.data.words)
                        console.log(response.data.config)
                        try {
                            setConfig(response.data.config)    
                        } catch(ex) {
                            console.log(repsonse.data.config)
                            setConfig(response.data.config)
                        }
                        
                    }
                } else {
                   setErrorMessage(response.data)
                }
            }).catch(error => {
                setErrorMessage(error.response.data)
                console.log(error)
            })
        } else {
            console.error("NO WORDCLOUD ID PROVIDED")
        }
    }

    useEffect(fetchWords, [word_cloud_id])
    //useInterval(fetchWords, props.refresh ? props.refresh : null)

    //

    return;
    /*

    if(fixed_words) {
        return <ReactWordcloud words={fixed_words} {...fixed_config}/>
    }

    return <ReactWordcloud words={words} {...config}/>



    return useMemo(() => { 
        if (!word_cloud_id) {
            return <div className="alert alert-danger">No ID for this word cloud provided.</div>
        }
        if (querying) {
            return <i className="fa fa-spinner fa-spin"/>
        }
        if (errorMessage) {
            return <div className="alert alert-danger">{String(errorMessage)}</div>
        }
        return <ReactWordcloud words={words} options={config}/>
    }, [words, querying, errorMessage, config])

    */
}